import React, { useEffect } from 'react';

import {
    LogoImage,
    AdditionalActionsButton,
    StyledMoreVertOutlinedIcon,
    StyledGetAppOutlinedIcon,
    ModalHeader, ModalTitle, BackBtn
} from "./TopBarRedesigned.styles";

export const YellowBackBtn = ({onClick}: {onClick: () => void}) => {
    return (<BackBtn
        onClick={onClick}
        startIcon={<img
            className="arrowIcon"
            alt="backArrow"
            src={"img/arrowLeftYellow.svg"}
        />}
    >
        <span>Back</span>
    </BackBtn>)
}

export enum AdditionalActionsIconType {
    more = 'more',
    download = 'download'
}

const IconsByType = {
    [AdditionalActionsIconType.more]: <StyledMoreVertOutlinedIcon />,
    [AdditionalActionsIconType.download]: <StyledGetAppOutlinedIcon />
}

interface TopBarRedesignedProps {
    onBack: () => void;
    title?: string;
    additionalActionsIconType?: AdditionalActionsIconType;
    onAdditionalActionsButtonClick?: () => void;
    isNoBackArrow?: boolean;
}

const TopBarRedesigned = (
    {
        onBack,
        title,
        onAdditionalActionsButtonClick,
        additionalActionsIconType = AdditionalActionsIconType.more,
        isNoBackArrow
    }: TopBarRedesignedProps) => {

        useEffect(() => {
            if ( window?.cordova ) {
                document.addEventListener("backbutton", onBack, false);
            }
    
            return () => {
                document.removeEventListener("backbutton", onBack, false);
            }
        }, [onBack])

    return (
        <ModalHeader>
            {!isNoBackArrow ? (
                <YellowBackBtn onClick={onBack} />
            ) : (
                <div style={{ minWidth: '40px' }} />
            )}
            <ModalTitle>{title || <LogoImage />}</ModalTitle>
            {onAdditionalActionsButtonClick ? (
                <AdditionalActionsButton className="no-fastclick" onClick={onAdditionalActionsButtonClick}>
                    {IconsByType[additionalActionsIconType]}
                </AdditionalActionsButton>
            ) : (
                <div style={{ minWidth: '40px' }} />
            )}
        </ModalHeader>
    )
}

export default TopBarRedesigned;
